<template>
    <div class="monitor-item-warp">
        <monitorTitle :nub="nub" :text="text" />
        <div class="box">
            <div class="row" v-for="(i,k) in list" :key="k">
                <div class="label">{{i.name}}</div>
                <div class="value">{{i.value}}</div>
                <!-- <dv-digital-flop :config="i.config" style="height:40px;" /> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            nub: {
                default: ''
            },
            text: {
                default: ''
            },
            list: {
                default: () => {
                    return []
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .monitor-item-warp {
        position: relative;
        top: -20px;
        width: 200px;

        .box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 32px 0;
            width: 100%;
            height: 238px;
            background-image: url("/static/images/home/monitor/1-2.png");
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;

            .row {
                padding: 0 32px;

                .label {
                    margin-bottom: 24px;
                    line-height: 1;
                    font-size: 14px;
                    letter-spacing: 1px;
                    color: #ffffff;
                }

                .value {
                    line-height: 1;
                    font-size: 28px;
                    font-style: italic;
                    letter-spacing: 1px;
                    color: #0fc4ff;
                }
            }
        }
    }
</style>
